"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var styled_components_1 = require("styled-components");
var react_intl_1 = require("react-intl");
var FormattedAuthMessage_1 = __importDefault(require("../FormattedAuthMessage"));
var Icon_1 = __importDefault(require("../Icon"));
var styles_1 = require("./styles");
var massey_1 = __importDefault(require("../Logo/brands/massey"));
var fendt_1 = __importDefault(require("../Logo/brands/fendt"));
var valtra_1 = __importDefault(require("../Logo/brands/valtra"));
var Footer = function (_a) {
    var messages = _a.messages, languageChange = _a.languageChange;
    var formatMessage = (0, react_intl_1.useIntl)().formatMessage;
    var name = (0, styled_components_1.useTheme)().name;
    var _b = (0, react_1.useState)(false), isLanguageOpen = _b[0], setIsLanguageOpen = _b[1];
    var footerLinks = [
        {
            id: 'privacy',
            msg: messages.privacy,
            url: 'https://www.agcocorp.com/privacy.html',
        },
        {
            id: 'termsAndCondition',
            msg: messages.termsAndCondition,
            url: 'https://www.agcocorp.com/legal.html',
        },
        {
            id: 'cookies',
            msg: messages.cookies,
            url: 'https://www.agcocorp.com/cookies.html',
        },
    ];
    var handleToggleLanguageOptions = function () {
        setIsLanguageOpen(function (old) { return !old; });
    };
    var handleSelectLanguage = function (language) {
        languageChange === null || languageChange === void 0 ? void 0 : languageChange.onChange(language);
        handleToggleLanguageOptions();
    };
    var currentLanguage = languageChange === null || languageChange === void 0 ? void 0 : languageChange.availableLanguages.find(function (lang) { return lang.id === languageChange.selectedLanguage; });
    var getAccessibleLabel = function (label) {
        var opensInNewTabText = messages.opensInNewTab ? formatMessage(messages.opensInNewTab) : '(opens in a new tab)';
        return "".concat(label, " ").concat(opensInNewTabText);
    };
    var getWebsiteAccessibleLabel = function (brandName) {
        var opensInNewTabText = messages.websiteOpensInNewTab
            ? formatMessage(messages.websiteOpensInNewTab)
            : 'Website (opens in a new tab)';
        return "".concat(brandName, " ").concat(opensInNewTabText);
    };
    return ((0, jsx_runtime_1.jsxs)(styles_1.FooterStyle, { children: [(0, jsx_runtime_1.jsx)(styles_1.StyledLogo, {}), name === 'agco' && ((0, jsx_runtime_1.jsxs)(styles_1.LogosContainer, { children: [(0, jsx_runtime_1.jsx)(styles_1.LogoContainer, __assign({ style: { height: '14px' }, target: "_blank", href: "https://www.fendt.com", rel: "noreferrer", "aria-label": getWebsiteAccessibleLabel('Fendt') }, { children: (0, jsx_runtime_1.jsx)(fendt_1.default, { variant: "primary", colorOverride: "white", mode: "dark" }) })), (0, jsx_runtime_1.jsx)(styles_1.LogoContainer, __assign({ style: { height: '29px' }, target: "_blank", href: "https://www.masseyferguson.com", rel: "noreferrer", "aria-label": getWebsiteAccessibleLabel('Massey Ferguson') }, { children: (0, jsx_runtime_1.jsx)(massey_1.default, { variant: "primary", colorOverride: "white", mode: "dark" }) })), (0, jsx_runtime_1.jsx)(styles_1.LogoContainer, __assign({ style: { height: '14px' }, target: "_blank", href: "https://www.valtra.com", rel: "noreferrer", "aria-label": getWebsiteAccessibleLabel('Valtra') }, { children: (0, jsx_runtime_1.jsx)(valtra_1.default, { variant: "primary", colorOverride: "white", mode: "dark" }) }))] })), (0, jsx_runtime_1.jsx)(styles_1.RightSide, __assign({ className: (0, classnames_1.default)({ withLanguageChange: !!languageChange }), as: "div" }, { children: messages.copyright1 && messages.copyright2 ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(FormattedAuthMessage_1.default, { message: messages.copyright1 }), ' ', (0, jsx_runtime_1.jsx)(FormattedAuthMessage_1.default, { message: messages.copyright2 })] }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)(styles_1.FooterLinks, { children: [footerLinks.map(function (item) {
                                        return ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [(0, jsx_runtime_1.jsx)(styles_1.FooterLink, __assign({ target: "_blank", href: item.url, size: "sm", variant: "negative", isExternal: true, "aria-label": getAccessibleLabel(formatMessage(item.msg)) }, { children: (0, jsx_runtime_1.jsx)(FormattedAuthMessage_1.default, { message: item.msg }) })), (0, jsx_runtime_1.jsx)("span", { children: "|" })] }, item.id));
                                    }), (0, jsx_runtime_1.jsx)("div", { id: "teconsent" })] }) })] })) : ((0, jsx_runtime_1.jsx)(FormattedAuthMessage_1.default, { message: messages.copyright })) })), !!languageChange && ((0, jsx_runtime_1.jsxs)(styles_1.LanguageSelector, { children: [(0, jsx_runtime_1.jsxs)(styles_1.LanguageOpener, __assign({ onClick: handleToggleLanguageOptions }, { children: [currentLanguage && (0, jsx_runtime_1.jsx)("img", { src: currentLanguage.imageUrl, alt: currentLanguage.label }), (0, jsx_runtime_1.jsx)(styles_1.LanguageOpenerText, __assign({ size: "lg", id: "current-language-text" }, { children: currentLanguage === null || currentLanguage === void 0 ? void 0 : currentLanguage.label })), (0, jsx_runtime_1.jsx)(Icon_1.default, { name: "chevron-".concat(isLanguageOpen ? 'up' : 'down') })] })), (0, jsx_runtime_1.jsx)(styles_1.LanguageOptions, __assign({ className: (0, classnames_1.default)({ hidden: !isLanguageOpen }) }, { children: languageChange.availableLanguages.map(function (language) {
                            if (language.id === languageChange.selectedLanguage) {
                                return null;
                            }
                            return ((0, jsx_runtime_1.jsxs)(styles_1.LanguageOption, __assign({ className: "language-change-option", onClick: function () { return handleSelectLanguage(language.id); }, "data-language-id": language.id }, { children: [language.imageUrl && (0, jsx_runtime_1.jsx)("img", { src: language.imageUrl, alt: language.label }), (0, jsx_runtime_1.jsx)(styles_1.LanguageOptionText, { children: language.label })] }), language.id));
                        }) }))] }))] }));
};
exports.default = Footer;
